import { computed, ref } from "vue";
import { ConvertDateTimeString, getIsMobile } from "./GlobalUtility";

export const currentDate = ref('');
export const nowDate = new Date(); // 오늘 날짜를 max 속성으로 제공

export const Statistics_StartDate = ref('');
export const Statistics_EndDate = ref('');

// 날짜 범위 생성 (YYYY-MM-DD 형식의 문자열 배열 반환)
export const getDateRange = () => {
  const result = [];
  const start = new Date(Statistics_StartDate.value);
  const end = new Date(Statistics_EndDate.value);

  while (start <= end) {
    const year = start.getFullYear();
    const month = String(start.getMonth() + 1).padStart(2, '0');
    const day = String(start.getDate()).padStart(2, '0');
    result.push(`${year}-${month}-${day}`);
    start.setDate(start.getDate() + 1);
  }
  
  return result;
};

export const datetimeRange = computed(() => {
  const start = new Date(Statistics_StartDate.value);
  const end = new Date(Statistics_EndDate.value);
  // 시작 시간을 00:00:00으로 설정
  start.setHours(0, 0, 0, 0);
  // 종료 시간을 23:59:59으로 설정
  end.setHours(23, 59, 59, 999);

  return '/?starttime=' + ConvertDateTimeString(start, 'YYYYMMDDHHMM')
          + '&endtime=' + ConvertDateTimeString(end, 'YYYYMMDDHHMM');
});

export const fontSizeTitle = computed(() => getIsMobile() ? 14 : 18);
export const fontSizeAxis = computed(() => getIsMobile() ? 12 : 16);